export default "__VITE_ASSET__CdGFyR8q__"